import { HTMLAttributes } from 'vue';

export function loadScript(
  url,
  integrity?: string,
  attrs?: object,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const script: any = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          resolve('ok');
        } else {
          reject('failed');
        }
      };
    } else {
      script.onload = () => {
        resolve('ok');
      };
    }

    if (integrity) {
      script.crossOrigin = 'anonymous';
      script.integrity = integrity;
    }

    if (attrs) {
      Object.keys(attrs).forEach(key => {
        script.setAttribute(key, attrs[key]);
      });
    }

    script.src = url;

    document.body.appendChild(script);
  });
}
